import AboutLinks from "./Links/About/AboutLinks";
import HelpLinks from "./Links/Help/HelpLinks";
import SocialIcons from "./SocialIcons/SocialIcons";
import logo from "../Assets/Images/Logo/LogoGreen.png";
import { motion } from "framer-motion";

// import { FaArrowDown } from "react-icons/fa";





const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.div
      layout
      dir="rtl"
      className="flex items-center justify-center w-screen bg-[#E1D7B7] relative "
    >
      {/* <div className="absolute top-2 right-5 p-2 rounded-lg bg-stone-200 flex-col items-center justify-center flex transform animate-bounce">
        <p>الالوان اللي هنا يا اسرااااء😂😂</p>

        <FaArrowDown />
      </div> */}
      <div className="flex items-center justify-center flex-col w-full py-5 px-5 gap-5">
        {/* Start-Logo-name*/}
        <div className="flex flex-col items-center justify-center gap-2">
          <div
            className="flex items-center justify-center w-[10rem] rounded-full  
        "
          >
            <img
              src={logo}
              alt="logo"
              className="flex items-center justify-center w-full h-full object-cover"
            />
          </div>
          <div>
            <p className="text-lg text-yellow-700">
              جرين تكنولوجي لصناعة الاسمده
            </p>
          </div>
        </div>
        {/* End-Logo-name */}
        {/* Start-Links */}
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center lg:justify-between gap-3 w-[80%]">
          {/* Start-about */}
          <AboutLinks />
          {/* End-about */}
          {/* Start-contact */}
          <HelpLinks />
          {/* End-contact */}
          {/* Start-SocialIcons */}
          <SocialIcons />
          {/* End-SocialIcons */}
        </div>
        {/* End-Links */}
        {/* Start-copyRights */}
        <div className="flex items-center justify-center w-full border-t-2 p-2 bg-stone-500 rounded-lg">
          <p className="text-gray-200">
            {" "}
            جميع حقوق النشر محفوظه {currentYear} &copy; جرين تكنولوجي
          </p>
        </div>
        {/* End-copyRights */}
      </div>
    </motion.div>
  );
};

export default Footer;
